import React from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Offer } from "@/types/offer";
interface TableHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  dateFilter: 'future' | 'past' | 'all' | 'placeholder';
  onDateFilterChange: (value: 'future' | 'past' | 'all' | 'placeholder') => void;
  pageSize: string;
  onPageSizeChange: (value: string) => void;
  selectedOffers: Offer[];
  renderBulkActions?: (selectedItems: Offer[]) => React.ReactNode;
  isAdmin?: boolean;
}
export const TableHeader: React.FC<TableHeaderProps> = ({
  searchTerm,
  onSearchChange,
  dateFilter,
  onDateFilterChange,
  pageSize,
  onPageSizeChange,
  selectedOffers,
  renderBulkActions,
  isAdmin
}) => {
  return <div className="flex flex-col gap-4 w-full">
      {/* Row 1: Search, Filter, and Page Size */}
      <div className="flex items-center justify-between gap-4">
        {/* Search input */}
        <div className="relative flex-1">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input placeholder="Search sessions..." className="w-full pl-9" value={searchTerm} onChange={e => onSearchChange(e.target.value)} />
        </div>

        {/* Date filter and Page Size selector */}
        <div className="flex items-center gap-4">
          <Select value={dateFilter} onValueChange={onDateFilterChange}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Filter by date" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="future">Future sessions</SelectItem>
              <SelectItem value="past">Past sessions</SelectItem>
              <SelectItem value="all">All sessions</SelectItem>
              {isAdmin && (
                <SelectItem value="placeholder">Placeholder sessions</SelectItem>
              )}
            </SelectContent>
          </Select>

          {/* Page size selector */}
          <div className="flex items-center gap-2">
            <span className="text-sm text-muted-foreground">Show</span>
            <Select value={pageSize} onValueChange={onPageSizeChange}>
              <SelectTrigger className="w-[70px]">
                <SelectValue placeholder="25" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="25">25</SelectItem>
                <SelectItem value="100">100</SelectItem>
                <SelectItem value="250">250</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      {/* Row 2: Always show selected count, but only show bulk actions when items are selected */}
      <div className="flex items-center gap-4">
        <span className="text-sm text-muted-foreground py-[10px]">{selectedOffers.length} selected</span>
        {renderBulkActions && renderBulkActions(selectedOffers)}
      </div>
    </div>;
};